import { ReactElement } from "react";
import { IKeyValueListProps } from "../../../interfaces/props/IKeyValueListProps";

import classes from "./KeyValueList.module.css";

/**
 * Компонент отображает список пар ключ-значение с опциональным заголовком.
 *
 * @param {IKeyValueListProps} props - Свойства компонента.
 * @param {Array<{key: string | ReactNode, value: string | ReactNode, id?: string}>} props.data - Массив объектов с парами ключ-значение и опциональным идентификатором этих пар.
 * @param {string} [props.className] - Дополнительные CSS-классы для корневого элемента компонента.
 * @param {string} [props.title] - Опциональный заголовок списка.
 */
export function KeyValueList(props: IKeyValueListProps): ReactElement {
  const { className, data, title } = props;

  return (
    <div className={`${className} ${classes.data}`}>
      {title && <h2 className={classes.data__title}>{title}</h2>}
      <dl className={classes.data__list}>
        {data.map((item) => (
          <div className={classes.data__item} key={item.id}>
            <dt className={classes.data__key}>{item?.key}</dt>
            <dd className={classes.data__value}>{item?.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
